
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-enroll",
      function () {
        return require("private-next-pages/why-enroll.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-enroll"])
      });
    }
  